<template>
    <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <!-- 下载表格 -->
        <div style="margin-top: 10%;width=100%;">
            <div style="display: flex;justify-content:space-between;">
             <label style="font-size:20px">凭证文件下载:</label>
             <div style="justify-content:flex-end;">
                 <el-link style="font-size:20px;" :href="downloadAllFileUrl + voucherHeardId +'&suffix='+ suffix + '&' + token">下载全部</el-link>
             </div>
             </div>
            <el-table :data="dowloadTableData" ref="dowloadTable" style="width: 1200px;" :default-sort = "{prop: 'date', order: 'descending'}" >
                <el-table-column prop="id" v-if="show == true">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="录入日期"
                    sortable
                    width="300px">
                </el-table-column>
                <el-table-column
                    prop="fileName"
                    label="文件名称"
                    sortable
                    width="300px">
                </el-table-column>
                <el-table-column
                    prop="voucherType"
                    label="类型"
                    width="300px"
                    :formatter="typeFormatter">
                </el-table-column>
                  <el-table-column label="操作" width="300px">
                    <template slot-scope="scoped">
                        <span v-if="scoped.row.voucherId && scoped.row.filePath.length > 0" style="margin-left:4px">
                            <el-link style="font-size:12px;" :href="downloadFileUrl + scoped.row.id +'&suffix='+ suffix+ '&' + token" 
                                :underline="false" type="primary"  >下载文件</el-link>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
	import https, { fetchGet, fetchPost } from '../../../https.js'
    export default {
        data(){
            return {
                show:false,
                dowloadTableData: [],
                downloadFileUrl: this.baseURL + '/dowload/dowloadAttachmentFile?id=',
                downloadAllFileUrl: this.baseURL+ '/dowload/dowloadAllAttachmentFile?id=',
                token: 'token=' + localStorage.getItem('token'),
                voucherHeardId:this.$route.query.voucherId,
                suffix:this.$route.query.suffix
            };
        },
        created() {
            this.getOriginalVoucherFileList();
        },
        methods: {
            //	获取凭证附件与影像数据
            async getOriginalVoucherFileList() {
            let voucherId = this.$route.query.voucherId;
            let suffix  = this.$route.query.suffix;
			let pwm = {"voucherId":voucherId,"suffix":suffix};
            fetchGet('/dowload/getVoucherFileList', pwm).then(res => {
                if(res.data.success){
                    this.loadTableData(res.data);
                }else{
                    this.$message.error(res.data.message); 
                }
				}, error => {
					this.$message.error('链接异常' + error);
				});
            },
            async loadTableData(result) {
                this.dowloadTableData = result.data;
            },

            //下载文件：
            handleDowload(row){
                console.log(row);
                
            },
            typeFormatter(row, column) {
                let type = "影像";
                if(row.pzlx == '2'){
                type = "附件"
                }
            return type;
        }
        }
    }


</script>    